import { render, staticRenderFns } from "./writeoff.vue?vue&type=template&id=13bfeb14&scoped=true&"
import script from "./writeoff.vue?vue&type=script&lang=js&"
export * from "./writeoff.vue?vue&type=script&lang=js&"
import style0 from "./writeoff.vue?vue&type=style&index=0&id=13bfeb14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bfeb14",
  null
  
)

export default component.exports